<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ep"> </p>
<p class="ep-bot">In her forties now she’d be, I don’t know, fifty, girding up her lovely little loins, getting ready for the change.</p>
<p class="epc">—Samuel Beckett, <span class="epub-i">All That Fall</span></p>
<p class="ep"> </p>
<p class="ep-bot">I know those are your hands … I know it, but to me they are white tarantulas, don’t touch me.</p>
<p class="epc">—Katherine Anne Porter, <span class="epub-i">Pale Horse, Pale Rider</span></p>
<p class="ep"> </p>
<p class="ep">Have you heard that poor, dear Blanche </p>
<p class="ep-bot">Got run down by an avalanche?</p>
<p class="epc">—Cole Porter, “Well, Did You Evah?”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?dbf5e3ac